module.exports = __webpack_public_path__ + "media/assets/images/nosco_cloud_and_io-88a82b07ccd77898a003d60ab9ba370d.png";